var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M16.5382 13.6206L15.1855 12.269C15.8255 11.6732 16.3273 10.9683 16.6909 10.1545C17.0545 9.34061 17.2364 8.47589 17.2364 7.5603C17.2364 6.64472 17.0545 5.78726 16.6909 4.98794C16.3273 4.18862 15.8255 3.49103 15.1855 2.89518L16.5382 1.5C17.3527 2.27025 18 3.17857 18.48 4.22496C18.96 5.27134 19.2 6.38312 19.2 7.5603C19.2 8.73748 18.96 9.84926 18.48 10.8957C18 11.942 17.3527 12.8504 16.5382 13.6206ZM13.7455 10.8303L12.3491 9.43507C12.6109 9.18801 12.8218 8.90825 12.9818 8.59579C13.1418 8.28332 13.2218 7.93816 13.2218 7.5603C13.2218 7.18244 13.1418 6.83728 12.9818 6.52482C12.8218 6.21236 12.6109 5.9326 12.3491 5.68553L13.7455 4.29035C14.2109 4.71181 14.5745 5.20231 14.8364 5.76183C15.0982 6.32136 15.2291 6.92085 15.2291 7.5603C15.2291 8.19976 15.0982 8.79925 14.8364 9.35877C14.5745 9.9183 14.2109 10.4088 13.7455 10.8303ZM6.98182 11.0483C6.02182 11.0483 5.2 10.7067 4.51636 10.0237C3.83273 9.34061 3.49091 8.51949 3.49091 7.5603C3.49091 6.60112 3.83273 5.78 4.51636 5.09694C5.2 4.41389 6.02182 4.07236 6.98182 4.07236C7.94182 4.07236 8.76364 4.41389 9.44727 5.09694C10.1309 5.78 10.4727 6.60112 10.4727 7.5603C10.4727 8.51949 10.1309 9.34061 9.44727 10.0237C8.76364 10.7067 7.94182 11.0483 6.98182 11.0483ZM0 18.0241V15.5826C0 15.103 0.123636 14.6525 0.370909 14.231C0.618182 13.8095 0.96 13.4898 1.39636 13.2718C2.13818 12.8939 2.97455 12.5742 3.90545 12.3126C4.83636 12.051 5.86182 11.9202 6.98182 11.9202C8.10182 11.9202 9.12727 12.051 10.0582 12.3126C10.9891 12.5742 11.8255 12.8939 12.5673 13.2718C13.0036 13.4898 13.3455 13.8095 13.5927 14.231C13.84 14.6525 13.9636 15.103 13.9636 15.5826V18.0241H0Z",
          fill: _vm.color,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }